import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-video-mute-button',
    templateUrl: './video-mute-button.component.html',
    styleUrls: ['./video-mute-button.component.scss']
})
export class VideoMuteButtonComponent {
    @Input() muted = true;
    @Output() mutedChange = new EventEmitter<boolean>();

    isRollover = false;

    ngOnInit(): void {
        this.onOver()
        setTimeout(() => {
            this.onOut()
        }, 3000);
    }

    get image(): string {
        return this.muted ? 'assets/img/icons/sound-off.png' : 'assets/img/icons/sound-on.png';
    }

    onClick() {
        this.mutedChange.emit(!this.muted);
    }

    onOver() {
        this.isRollover = true;
    }

    onOut() {
        this.isRollover = false;
    }
}
